import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import ContentSearch from '../ContentSearch';

const PREFIX = 'Toolbar';

const classes = {
  container: `${PREFIX}-container`,
  search: `${PREFIX}-search`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(3),
  },

  [`& .${classes.search}`]: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

interface ToolbarProps {
  currentFilter: string;
  searchIcon: React.ReactNode;
  searchPlaceholder: string;
  currentSearchString: string;
  onSearchChange: (val: string) => void;
}

export default function Toolbar({
  searchIcon,
  searchPlaceholder,
  currentSearchString,
  onSearchChange,
}: ToolbarProps) {
  return (
    <StyledBox className={classes.container}>
      <Box className={classes.search}>
        <ContentSearch
          icon={searchIcon}
          placeholder={searchPlaceholder}
          currentSearchFilter={currentSearchString}
          onSearchChange={onSearchChange}
        />
      </Box>
    </StyledBox>
  );
}
